// polyfill
import 'focus-visible';

import { Provider as ReduxProvider } from 'react-redux';

// some components use i18n in the defaultProps which are evaluated
// at require time (so when we require Layout). This still has to
// be required before anything else
import './init/locale';

import ApolloApiProvider from '@wetransfer/transfer/apollo-api/src';
import { client as apolloClient } from '@wetransfer/transfer/apollo-api/usage';
import Auth from '@wetransfer/transfer/auth-bundle/components/Auth';
import {
  client,
  Provider as GraphQLProvider,
} from '@wetransfer/transfer/_graphql';
import ViewportProvider from '@wetransfer/transfer/hooks/useViewport/ViewportProvider';
import Router from '@wetransfer/transfer/modules/router';
import { TransferApp } from '@wetransfer/transfer/page/TransferApp/TransferApp';
import Store from '@wetransfer/transfer/store';

import { initRouting } from './init';

initRouting();

const App = () => {
  return (
    <ReduxProvider store={Store}>
      <ApolloApiProvider client={apolloClient}>
        <GraphQLProvider value={client}>
          <ViewportProvider>
            <Auth navigateTo={Router.navigateTo} />
            <TransferApp />
          </ViewportProvider>
        </GraphQLProvider>
      </ApolloApiProvider>
    </ReduxProvider>
  );
};

export default App;
